export const TEST_ID_PREFIX = 'error-state';

export const ERROR_STATE_VARIANTS = {
  ERROR: 'error',
  NETWORK: 'network',
} as const;

export const ERROR_TITLE = 'Oops! Something Went Wrong';

export const ERROR_DESCRIPTION = [
  'We were unable to perform the operation.',
  'Please try again or contact support for further assistance.',
];

export const NETWORK_TITLE = 'Connection Error';

export const NETWORK_DESCRIPTION = ['No internet found. Check your connection and try again.'];

export const RETRY_LABEL = 'Retry';
